'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = OnlinepbxModal;

var _onlinepbxButtonLink = require('../onlinepbx-button-link');

var _onlinepbxButtonLink2 = _interopRequireDefault(_onlinepbxButtonLink);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function OnlinepbxModal(_ref) {
  var title = _ref.title,
      description = _ref.description,
      textLeft = _ref.textLeft,
      handleClose = _ref.handleClose,
      buttonCenter = _ref.buttonCenter,
      isRightRed = _ref.isRightRed,
      onClickLeft = _ref.onClickLeft,
      textButtonLeft = _ref.textButtonLeft,
      onClickRight = _ref.onClickRight,
      textButtonRight = _ref.textButtonRight,
      textButtonCenter = _ref.textButtonCenter,
      onClickCenter = _ref.onClickCenter,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ['title', 'description', 'textLeft', 'handleClose', 'buttonCenter', 'isRightRed', 'onClickLeft', 'textButtonLeft', 'onClickRight', 'textButtonRight', 'textButtonCenter', 'onClickCenter', 'className']);

  return _react2['default'].createElement(
    'div',
    _extends({
      onClick: function () {
        function onClick() {
          return typeof handleClose === 'function' && handleClose();
        }

        return onClick;
      }(),
      className: 'onlinepbx__lib__modal'
    }, otherProps),
    _react2['default'].createElement(
      'div',
      {
        onClick: function () {
          function onClick(evt) {
            return evt.stopPropagation();
          }

          return onClick;
        }(),
        className: (0, _classnames2['default'])('onlinepbx__lib__modal__window', className) },
      _react2['default'].createElement(
        'div',
        {
          style: textLeft ? { textAlign: 'left' } : {},
          className: 'onlinepbx__lib__modal__title' },
        title
      ),
      description && _react2['default'].createElement(
        'div',
        {
          style: textLeft ? { textAlign: 'left' } : {},
          className: 'onlinepbx__lib__modal__description' },
        description
      ),
      !buttonCenter && _react2['default'].createElement(
        'div',
        { className: 'onlinepbx__lib__modal__footer' },
        _react2['default'].createElement(
          'div',
          { className: 'onlinepbx__lib__modal__button' },
          _react2['default'].createElement(_onlinepbxButtonLink2['default'], {
            onClick: function () {
              function onClick() {
                return typeof onClickLeft === 'function' && onClickLeft();
              }

              return onClick;
            }(),
            className: 'onlinepbx__lib__modal__button__wrapper',
            text: textButtonLeft
          })
        ),
        _react2['default'].createElement(
          'div',
          { className: 'onlinepbx__lib__modal__button' },
          _react2['default'].createElement(_onlinepbxButtonLink2['default'], {
            onClick: function () {
              function onClick() {
                return typeof onClickRight === 'function' && onClickRight();
              }

              return onClick;
            }(),
            className: 'onlinepbx__lib__modal__button__wrapper',
            text: textButtonRight,
            isDelete: isRightRed
          })
        )
      ) || _react2['default'].createElement(
        'div',
        { className: 'onlinepbx__lib__modal__footer' },
        _react2['default'].createElement(
          'div',
          { className: 'onlinepbx__lib__modal__button' },
          _react2['default'].createElement(_onlinepbxButtonLink2['default'], {
            className: 'onlinepbx__lib__modal__button__wrapper',
            text: textButtonCenter,
            onClick: function () {
              function onClick() {
                return typeof onClickCenter === 'function' && onClickCenter();
              }

              return onClick;
            }()
          })
        )
      )
    )
  );
}